<template>
  <div>
    <v-layout class="mt-2 mb-2">
      <v-flex xs6>
        <BuscaSimplesApi label="Buscar" :disabled="acao != ''" route="merenda/fornecedor" :fieldSearch="buscarSelect"
          @found="encontrado" ref="buscaSimpleApi">
          <template slot-scope="propSlot">
            <span>{{ propSlot.item.nomefornecedor }}</span>
          </template>
        </BuscaSimplesApi>
      </v-flex>
      <v-flex xs4 class="ml-3">
        <Select :options="buscaOptions" v-model="buscarSelect" label="" @change="selectBuscaChange" />
      </v-flex>
    </v-layout>

    <v-alert type="error" :value="($v.$invalid && $v.$dirty) || msgArrayError.length > 0" style="color: white;">
      <div v-if="$v.$invalid && $v.$dirty"> Preencha os campos corretamente.</div>
      <div v-if="msgArrayError.length > 0">
        <ul v-for="error of msgArrayError" :key="error.key">
          <li>{{ error }}</li>
        </ul>
      </div>
    </v-alert>

    <FormBasico :acao="acao" :id="form.identificadorfornecedor" :novo="novoFornecedor" :editar="editarFornecedor"
      :excluir="excluirFornecedor" :cancelar="cancelarFornecedor" :submit="onSubmit">
      <v-tabs>
        <v-tabs-slider color="#fff"></v-tabs-slider>
        <v-tab @click="tabelaFornecedor">
          <v-icon left color="#757575">view_list</v-icon>
        </v-tab>
      </v-tabs>
      <v-card>
        <v-card-text>
          <Input type="text" label="Código do Fornecedor" v-model="form.identificadorfornecedor" disabled />
          <Input type="text" label="Nome do Fornecedor" ref="focusCampo" v-model="form.nomefornecedor"
            :disabled="acao == '' || acao == 'excluir'" :v="$v.form.nomefornecedor" />
          <Input type="text" label="E-mail do Fornecedor" v-model="form.emailcontatofornecedor"
            :disabled="acao == '' || acao == 'excluir'" :v="$v.form.emailcontatofornecedor" />
          <InputMask :mask="['(##) ####-####', '(##) #####-####']" label="Telefone do Fornecedor" :disabled="acao == '' || acao == 'excluir'"
           v-model="form.numerotelefonecontatofornecedor" :v="$v.form.numerotelefonecontatofornecedor"/>

          <!-- <Input type="text" label="Telefone do Fornecedor" v-model="form.numerotelefonecontatofornecedor"
          :disabled="acao == '' || acao == 'excluir'" :v="$v.form.numerotelefonecontatofornecedor" /> -->
        </v-card-text>
      </v-card>
    </FormBasico>

    <v-snackbar v-model="snackbar" bottom left :timeout="4000" height="10px" rounded="0"  >
        <div class="d-flex justify-space-between align-center">
           <span> {{ submitText }}</span>
            <v-btn class="text-right" variant="text"  icon  @click="snackbar = false" > <v-icon>close</v-icon> </v-btn>
        </div>
    </v-snackbar>
  </div>
</template>

<script>
import BuscaSimplesApi from '@/components/BuscaSimplesApi';
import { required, minLength, maxLength, email } from 'vuelidate/lib/validators';
import { RepositoryFactory } from "@/repositories/RepositoryFactory";

const FornecedorRepository = RepositoryFactory.get("fornecedorRepository")

const setFormInicial = () => ({
  identificadortipomovimento: '',
  nomefornecedor: '',
  emailcontatofornecedor: '',
  numerotelefonecontatofornecedor: '',
});

export default {
  name: 'Fornecedor',
  components: { BuscaSimplesApi },
  data() {
    return {
      acao: '',
      form: setFormInicial(),
      submitText: '',
      snackbar: false,
      msgArrayError: [],
      buscarSelect: 'nomefornecedor',
      buscaOptions: [
        { value: 'identificadorfornecedor', text: 'Código' },
        { value: 'nomefornecedor', text: 'Nome do Fornecedor' },
      ],
      formUltimo: {},
    };
  },
  validations: {
    form: {
      nomefornecedor: { required, maxLength: maxLength(100) },
      emailcontatofornecedor: { email, maxLength: maxLength(100) },
      numerotelefonecontatofornecedor: { maxLength: maxLength(11), minLength: minLength(10) },
    },

  },

  mounted() {
    this.$Progress.finish();
  },
  methods: {
    tabelaFornecedor() {
      this.$root.$router.push({
        name: 'tabelas',
        params: {
          titulo: 'Fornecedor / Listar',
          rota_api: 'merenda/fornecedor/tabela',
          headers: [{ text: 'Identificador', value: 'identificadorfornecedor', sortable: false },
          { text: 'Título', value: 'nomefornecedor', sortable: false }],
        },
      });
    },
    novoFornecedor() {
      this.acao = 'novo';
      this.form = setFormInicial();
      this.$v.$reset();
      setTimeout(() => this.$refs.focusCampo.$refs.input.focus(), 200);
    },
    editarFornecedor() {
      this.acao = 'editar';
    },
    cancelarFornecedor() {
      if (this.acao == 'novo') {
        this.form = setFormInicial();
      } else {
        this.form = { ...this.formUltimo };
      }
      this.acao = '';
      this.msgArrayError = [];
      this.$v.$reset();
    },
    async excluirFornecedor() {
      this.acao = 'excluir';

      const confirmar = await this.$sgal({
        title: 'Tem certeza?',
        text: 'Deseja realmente excluir este fornecedor?',
        type: 'warning',
        buttons: [
          { text: 'Sim, excluir', color: 'red', response: true },
          { text: 'Não, cancelar', color: 'grey', response: false },
        ],
      });

      if (confirmar) {
        try {
          const { data } = await FornecedorRepository.deletarFornecedor(this.form.identificadorfornecedor);

          this.submitText = data.message;
          this.snackbar = true;
          this.form = setFormInicial();
          this.msgArrayError = [];
        } catch (error) {
          const ntfExcluir = await this.$sgal({
            title: 'Não foi possível!',
            text: error.response.data.errorMessage[0],
            type: 'notification',
          });
        }
      }

      this.acao = '';
    },

    async onSubmit() {
      this.$v.$touch();

      if (this.$v.$invalid) return;

      try {
        const { data } = await FornecedorRepository[this.acao === 'novo' ? 'criarFornecedor' : 'editarFornecedor'](this.form);

        this.acao = '';
        this.submitText = data.message;
        this.snackbar = true;
        this.msgArrayError = [];
        this.form = { ...data.results };
        this.formUltimo = { ...this.form };

      } catch (error) {
        if (error.response.data.status == 'ERROR_BUSINESS_RULE') { this.msgArrayError = error.response.data.errorMessage; }
        if (window.scrollY >= 250) { window.scrollTo({ top: 0, behavior: 'smooth' }); }
      }

      this.$v.$reset();
    },
    encontrado(dados) {
      this.form = setFormInicial();
      this.form = { ...dados };
      this.formUltimo = { ...dados };
      this.$refs.buscaSimpleApi.lista = [];
    },
    selectBuscaChange() {
      this.$refs.buscaSimpleApi.busca = '';
    },
  },
};
</script>

<style></style>
